import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {ApiDetails, KEY} from "../../dummyData";
import CryptoJS from "crypto-js";
import logo from "../../assets/react-logo-no-background.svg";
import {useFeatureFlags} from "../../context/FeatureFlagsContext";

const LoginPageModern = (props) => {
    const navigate = useNavigate();
    const { refresh: refreshFlags } = useFeatureFlags();

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [touched, setTouched] = useState({firstName: false, accountNumber: false});

    const validateForm = () => {
        const errors = {};
        if (!firstName) errors.firstName = "First name is required";
        if (!accountNumber) errors.accountNumber = "Account number is required";
        return errors;
    };

    const handleBlur = (field) => {
        setTouched({...touched, [field]: true});
    };

    const handleSubmit = () => {
        // Mark all fields as touched for validation display
        setTouched({firstName: true, accountNumber: true});

        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setError("Please fill in all required fields");
            return;
        }

        setLoading(true);
        setError("");

        const body = {
            "first_name": firstName,
            "account_number": accountNumber,
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/app/login", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 403) {
                    // Session expired - redirect to login
                    localStorage.clear();
                    window.location.href = "/";
                    return;
                }

                if (response.status === 200) {
                    storeUserDetails(data);
                } else if (response.status === 401 || response.status === 400) {
                    setLoading(false);
                    props.snackBar({
                        text: "Invalid credentials. Please check your details and try again.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                props.snackBar({
                    text: "Connection error. Please try again later.",
                    type: "error",
                });
            });
    };

    const storeUserDetails = (userDetails) => {
        userDetails = {
            ...userDetails,
            copy_of_contract: "",
            inventory_checklist: "",
            photo_of_national_id: "",
            tenant_photo: ""
        };

        let details = CryptoJS.AES.encrypt(
            JSON.stringify(userDetails),
            KEY
        ).toString();

        localStorage.setItem("tenant_details", details);

        const isIdVerified = userDetails.id_verification_status;

        console.log("id_verification_status")
        console.log(isIdVerified)


        if (isIdVerified.toString().trim().toUpperCase() === "PENDING") {
            navigate("/verify/account");
        } else {
            navigate("/home");
        }

        props.refresh(true);
        props.snackBar({text: "Login Successful", type: "success"});
        props.fn();
        setLoading(false);
        refreshFlags();
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 1000,
                display: "flex",
                height: "100vh",
                width: "100vw",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #f0f4f8 0%, #d0d9e6 100%)",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
            }}
        >
            <div
                style={{
                    maxWidth: "28rem",
                    width: "90%",
                    margin: "0 auto"
                }}
            >
                <div
                    style={{
                        backgroundColor: "white",
                        borderRadius: "0.75rem",
                        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
                        padding: "2.5rem",
                        marginBottom: "1.5rem",
                        transition: "all 0.2s ease"
                    }}
                >
                    {/* Logo & Header */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "2rem"
                        }}
                    >
                        <div
                            style={{
                                height: "4.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "1.5rem"
                            }}
                        >
                            <img
                                style={{
                                    width: "200px",
                                    height: "auto",
                                    objectFit: "contain"
                                }}
                                src={logo}
                                alt="ITORAMA Logo"
                            />
                        </div>

                        <h1
                            style={{
                                fontSize: "1.75rem",
                                lineHeight: "2.25rem",
                                fontWeight: "700",
                                color: "#1f2937",
                                margin: "0 0 0.5rem 0"
                            }}
                        >
                            Welcome Back
                        </h1>
                        <p
                            style={{
                                color: "#6b7280",
                                fontSize: "1rem",
                                lineHeight: "1.5rem",
                                margin: 0
                            }}
                        >
                            Sign in to continue to your account
                        </p>
                    </div>

                    {/* Error message */}
                    {error && (
                        <div
                            style={{
                                backgroundColor: "#fef2f2",
                                border: "1px solid #fee2e2",
                                color: "#b91c1c",
                                padding: "0.75rem 1rem",
                                borderRadius: "0.5rem",
                                marginBottom: "1.5rem",
                                fontSize: "0.875rem",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem"
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                 strokeWidth="2">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="12" y1="8" x2="12" y2="12"/>
                                <line x1="12" y1="16" x2="12.01" y2="16"/>
                            </svg>
                            {error}
                        </div>
                    )}

                    {/* Login Form */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1.5rem"
                        }}
                    >
                        <div>
                            <label
                                htmlFor="first_name"
                                style={{
                                    display: "block",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontWeight: "500",
                                    color: "#374151",
                                    marginBottom: "0.5rem"
                                }}
                            >
                                First Name <span style={{color: "#ef4444"}}>*</span>
                            </label>
                            <input
                                type="text"
                                id="first_name"
                                style={{
                                    width: "100%",
                                    padding: "0.75rem 1rem",
                                    border: `1px solid ${touched.firstName && !firstName ? "#ef4444" : "#d1d5db"}`,
                                    borderRadius: "0.5rem",
                                    outline: "none",
                                    fontSize: "1rem",
                                    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                    boxSizing: "border-box",
                                    boxShadow: touched.firstName && !firstName
                                        ? "0 0 0 1px #ef4444"
                                        : "none"
                                }}
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value.trim())}
                                onBlur={() => handleBlur("firstName")}
                                placeholder="Enter your first name"
                            />
                            {touched.firstName && !firstName && (
                                <p style={{
                                    color: "#ef4444",
                                    fontSize: "0.75rem",
                                    marginTop: "0.25rem",
                                    marginBottom: 0
                                }}>
                                    First name is required
                                </p>
                            )}
                        </div>

                        <div>
                            <label
                                htmlFor="account_number"
                                style={{
                                    display: "block",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontWeight: "500",
                                    color: "#374151",
                                    marginBottom: "0.5rem"
                                }}
                            >
                                Account Number <span style={{color: "#ef4444"}}>*</span>
                            </label>
                            <div
                                style={{
                                    position: "relative"
                                }}
                            >
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="account_number"
                                    style={{
                                        width: "100%",
                                        padding: "0.75rem 1rem",
                                        paddingRight: "3rem",
                                        border: `1px solid ${touched.accountNumber && !accountNumber ? "#ef4444" : "#d1d5db"}`,
                                        borderRadius: "0.5rem",
                                        outline: "none",
                                        fontSize: "1rem",
                                        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                        boxSizing: "border-box",
                                        boxShadow: touched.accountNumber && !accountNumber
                                            ? "0 0 0 1px #ef4444"
                                            : "none"
                                    }}
                                    value={accountNumber}
                                    onChange={(e) => setAccountNumber(e.target.value.trim())}
                                    onBlur={() => handleBlur("accountNumber")}
                                    placeholder="Enter your account number"
                                />
                                <button
                                    type="button"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "0.75rem",
                                        transform: "translateY(-50%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "0.25rem",
                                        backgroundColor: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "#6b7280"
                                    }}
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                             strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
                                            <path
                                                d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/>
                                            <path
                                                d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/>
                                            <line x1="2" x2="22" y1="2" y2="22"/>
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                             strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
                                            <circle cx="12" cy="12" r="3"/>
                                        </svg>
                                    )}
                                </button>
                            </div>
                            {touched.accountNumber && !accountNumber && (
                                <p style={{
                                    color: "#ef4444",
                                    fontSize: "0.75rem",
                                    marginTop: "0.25rem",
                                    marginBottom: 0
                                }}>
                                    Account number is required
                                </p>
                            )}
                        </div>

                       {/* <div style={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}>
                            <a
                                href="#"
                                style={{
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    color: "#2563eb",
                                    textDecoration: "none",
                                    transition: "color 0.15s ease-in-out",
                                    fontWeight: "500"
                                }}
                            >
                                Forgot your account number?
                            </a>
                        </div>*/}

                        <button
                            type="button"
                            style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "0.875rem 1.25rem",
                                border: "none",
                                borderRadius: "0.5rem",
                                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                                fontSize: "1rem",
                                lineHeight: "1.5rem",
                                fontWeight: "500",
                                color: "white",
                                backgroundColor: "#2563eb",
                                cursor: loading ? "not-allowed" : "pointer",
                                opacity: loading ? "0.7" : "1",
                                transition: "background-color 0.15s ease-in-out, transform 0.1s ease-in-out",
                                marginTop: "1rem"
                            }}
                            onClick={loading ? null : handleSubmit}
                            disabled={loading}
                        >
                            {loading ? (
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                }}>
                                    <svg
                                        style={{
                                            animation: "spin 1s linear infinite",
                                            height: "1.25rem",
                                            width: "1.25rem"
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            style={{opacity: "0.25"}}
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            style={{opacity: "0.75"}}
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    Signing in...
                                </div>
                            ) : (
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                }}>
                                    <span>Sign In</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round">
                                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                                        <polyline points="10 17 15 12 10 7"/>
                                        <line x1="15" x2="3" y1="12" y2="12"/>
                                    </svg>
                                </div>
                            )}
                        </button>

                        {/* Help Link */}
                        <div style={{
                            textAlign: "center",
                            marginTop: "1rem"
                        }}>
                            <p style={{
                                fontSize: "0.875rem",
                                lineHeight: "1.25rem",
                                color: "#6b7280",
                                margin: 0
                            }}>
                                Need help? <a href="#"
                                              style={{color: "#2563eb", textDecoration: "none", fontWeight: "500"}}>Contact
                                support</a>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{textAlign: "center"}}>
                    <p style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.25rem",
                        color: "#6b7280",
                        margin: 0
                    }}>
                        © 2025 ITORAMA. All rights reserved.
                    </p>
                </div>
            </div>
            <style jsx>{`
                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }

                input:focus {
                    border-color: #2563eb !important;
                    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2) !important;
                }

                button:hover:not(:disabled) {
                    background-color: #1d4ed8;
                    transform: translateY(-1px);
                }

                button:active:not(:disabled) {
                    transform: translateY(0);
                }

                a:hover {
                    color: #1d4ed8;
                    text-decoration: underline;
                }
            `}</style>
        </div>
    );
};

export default LoginPageModern;